import { Fragment } from 'react';

const ProgressStepper = ({
  value = 1,
  setValue,
  stepperNames,
}: {
  value?: number;
  setValue?: (val: number) => void;
  stepperNames: Array<string>;
}) => {
  const Step = () => <div className="step-divider" />;

  return (
    <div className="stepper-container" style={{}}>
      <div className="stepper-line">
        {stepperNames?.map((step, index) => (
          <Fragment key={index}>
            <div
              onClick={() => {
                setValue?.(index + 1);
              }}
              className={`stepper-button ${value >= index + 1 ? 'stepper-border-active' : 'stepper-border-inactive'}`}
            >
              <div className={`stepper-inner-circle  ${value >= index + 1 ? 'stepper-inner-circle-active' : 'stepper-inner-circle-inactive'}`}></div>
            </div>
            {index < stepperNames.length - 1 && <Step />}
          </Fragment>
        ))}
      </div>

      <div className="stepper-label">
        {stepperNames?.map((step, index) => (
          <div key={index} className={`stepper-label-txt  ${value >= index + 1 ? 'stepper-label-txt-active' : 'stepper-label-txt-inactive'}`}>
            {step}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressStepper;
